import { Gender, BabyDeliveryMode } from '../../generated';

export const AllGenders = Object.values(Gender);

export enum BabyDiet {
  Breastmilk = 'Breastmilk',
  Formula = 'Formula',
  Solids = 'Solids',
}

export interface Baby {
  id: string;
  name: string;
  delivery: BabyDeliveryMode;
  preterm: boolean;
  dob: string;
  gender: Gender;
}
